import * as React from 'react';

import StepItem from './StepItem';
import './steps.css';

import { StepMarkerType, StepItemData, StepsProps } from '../../types';

class Steps extends React.Component<StepsProps, any> {
  public constructor(props: StepsProps) {
    super(props);
  }

  public render() {
    // Default to using children for step items
    let stepItems = [ this.props.children ];

    if (this.props.stepData) {
      // If stepData is provided as a prop, generate them instead of using children
      stepItems = this.props.stepData.map((item: StepItemData, index: number) => (
          <StepItem
              key={index}
              isActive={this.isActive(this.props.activeId, index)}
              markerType={this.computerMarker(this.props.activeId, index)}
              stepId={index + 1}
              stepTitle={item.title}
          >
            {item.details}
          </StepItem>
      ));
    }

    return (
      <div className="steps" id={this.props.id}>
        {...stepItems}
      </div>
    );
  }

  /**
   * Check if the StepItem should be active.
   *
   * @param activeId The currently active page
   * @param stepId The ID of the StepItem to check for
   * @return True if the step is active
   */
  private isActive = (activeId: number, stepId: number) => activeId === stepId;

  /**
   * Decide the type of marker to use for the StepItem
   *
   * @param activeId The currently active page
   * @param stepId The ID of the StepItem to check for
   * @return StepMarkerType
   */
  private computerMarker = (activeId: number, stepId: number) =>
      (stepId === this.props.stepData!.length - 1)
          ? StepMarkerType.GOAL
          : (activeId > stepId)
              ? StepMarkerType.COMPLETED
              : StepMarkerType.REGULAR;
}

export default Steps;



// WEBPACK FOOTER //
// ./src/common/steps/Steps.tsx